var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_165_852)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7477 4.37813C6.95062 4.96178 3.53493 9.32376 4.11859 14.1209C4.70224 18.918 9.06422 22.3337 13.8613 21.75C18.6584 21.1664 22.0741 16.8044 21.4905 12.0073C20.9068 7.21016 16.5448 3.79448 11.7477 4.37813ZM2.62957 14.302C1.94586 8.68256 5.94709 3.57282 11.5666 2.88911C17.186 2.2054 22.2958 6.20663 22.9795 11.8261C23.2888 14.3679 22.6395 16.8054 21.3156 18.7762L24.9582 21.6286C25.2843 21.8839 25.3417 22.3553 25.0863 22.6815C24.831 23.0076 24.3596 23.0649 24.0334 22.8096L20.3908 19.9572C18.795 21.715 16.5843 22.9298 14.0425 23.239C8.42302 23.9228 3.31328 19.9215 2.62957 14.302Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_165_852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 3.03717) rotate(-6.93695)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6bfdad5d964249cd7903e99a6416fb99.svg";
export { ForwardRef as ReactComponent };